export const parsePortfolioIds = (portfoliosRaw = '') =>
  portfoliosRaw
    ? portfoliosRaw
        .split(',')
        .map((id) => id.trim())
        .filter((id) => /^[1-9]\d*$/.test(id))
        .map(Number)
        .filter(Number.isSafeInteger)
    : []

export const isInsightsPathname = (pathname = '') =>
  pathname === '/insights' || pathname.startsWith('/insights/')

export const canAccessInsights = (user) => !user?.isTasksOnlyUser

export const getInsightsRouteState = ({ pathname = '/insights', basePath = '/insights' }) => {
  const isDetailRoute = pathname !== basePath

  return {
    isDetailRoute,
    isPropertySidebarCollapsed: isDetailRoute,
  }
}
